/**
 * Tradução dos textos do carrinho (cart drawer e página /cart).
 *
 * Arquivo INDEPENDENTE dos outros scripts de tradução — pode rodar junto,
 * um não interfere no outro.
 *
 * Diferença em relação aos anteriores: o carrinho é re-renderizado inteiro a
 * cada alteração (add/remove/qty), então aqui o observer traduz apenas os nós
 * que mudaram, em vez de varrer a seção toda. Por isso o escopo pode ser o
 * body sem custo relevante.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // CONFIGURAÇÃO
  // ---------------------------------------------------------------------------

  // O drawer é movido/recriado no DOM, então o padrão é o documento inteiro.
  // As frases são específicas o bastante para não colidirem com o resto do site.
  // Se preferir restringir: ['.cart-drawer', '.cart-block', '.cart-page']
  var TARGETS = ['body'];

  // Chaves maiores são aplicadas primeiro, então "Discount code cannot be
  // applied to your cart" ganha de "Discount code", que ganha de "Discount".
  var DICT = {
    'DISCOUNT': 'DESCONTO',
    'DISCOUNT CODE': 'CÓDIGO DE DESCONTO',
    'APPLY A DISCOUNT CODE': 'APLIQUE UM CÓDIGO DE DESCONTO',
    'APPLY': 'APLICAR',
    'DISCOUNT CODE CANNOT BE APPLIED TO YOUR CART': 'O CÓDIGO DE DESCONTO NÃO PODE SER APLICADO AO SEU CARRINHO',
    'SHIPPING DISCOUNTS ARE SHOWN AT CHECKOUT AFTER ADDING AN ADDRESS': 'OS DESCONTOS DE FRETE SÃO EXIBIDOS NO CHECKOUT APÓS ADICIONAR UM ENDEREÇO',
    'ADD A NOTE TO YOUR ORDER': 'ADICIONE UMA OBSERVAÇÃO AO SEU PEDIDO',
    'LEAVE A NOTE FOR SELLER': 'DEIXE UMA OBSERVAÇÃO PARA O VENDEDOR',
    'TAX INCLUDED AND SHIPPING CALCULATED AT CHECKOUT': 'IMPOSTOS INCLUÍDOS E FRETE CALCULADO NO CHECKOUT'

    // Outros textos comuns de carrinho — descomente conforme aparecerem:
    // , 'SUBTOTAL': 'SUBTOTAL'
    // , 'CHECK OUT': 'FINALIZAR COMPRA'
    // , 'CHECKOUT': 'FINALIZAR COMPRA'
    // , 'YOUR CART': 'SEU CARRINHO'
    // , 'YOUR CART IS EMPTY': 'SEU CARRINHO ESTÁ VAZIO'
    // , 'CONTINUE SHOPPING': 'CONTINUAR COMPRANDO'
    // , 'REMOVE': 'REMOVER'
    // , 'QUANTITY': 'QUANTIDADE'
    // , 'TOTAL': 'TOTAL'
  };

  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt', 'data-placeholder', 'label'];

  // ---------------------------------------------------------------------------

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, SVG: 1, TEMPLATE: 1 };
  var SELECTOR = TARGETS.join(',');

  var roots = [];
  var applying = false;
  var rescanQueued = false;

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  var RE = (function () {
    var keys = Object.keys(DICT).sort(function (a, b) { return b.length - a.length; });
    var partes = keys.map(function (k) {
      // espaços viram \s+ para tolerar quebras de linha do Liquid
      return escapeRe(k).replace(/\s+/g, '\\s+');
    });
    return new RegExp('(?<![\\w-])(' + partes.join('|') + ')(?![\\w-])', 'gi');
  })();

  function matchCase(original, translated) {
    if (original === original.toUpperCase()) return translated.toUpperCase();
    if (original === original.toLowerCase()) return translated.toLowerCase();
    return translated.charAt(0).toUpperCase() + translated.slice(1).toLowerCase();
  }

  function traduzir(text) {
    return text.replace(RE, function (m) {
      var chave = m.replace(/\s+/g, ' ').toUpperCase();
      var alvo = DICT[chave];
      if (!alvo) return m;
      return matchCase(m, alvo);
    });
  }

  function traduzirNoDeTexto(node) {
    if (!node.nodeValue || !node.nodeValue.trim()) return;
    var parent = node.parentNode;
    if (parent && SKIP_TAGS[parent.nodeName]) return;
    var novo = traduzir(node.nodeValue);
    if (novo !== node.nodeValue) node.nodeValue = novo;
  }

  function traduzirAtributosDoElemento(el) {
    for (var j = 0; j < ATTRS.length; j++) {
      var attr = ATTRS[j];
      var val = el.getAttribute && el.getAttribute(attr);
      if (!val) continue;
      var novo = traduzir(val);
      if (novo !== val) el.setAttribute(attr, novo);
    }

    // value só em botões — nunca em campo de texto, pra não sujar o valor
    // digitado nem o código de desconto enviado ao Shopify.
    if (el.tagName === 'INPUT' && /^(button|submit|reset)$/i.test(el.type) && el.value) {
      var nv = traduzir(el.value);
      if (nv !== el.value) el.value = nv;
    }
  }

  // Varredura completa: usada na carga inicial e quando um root novo aparece.
  function traduzirSubarvore(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      traduzirNoDeTexto(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (SKIP_TAGS[root.nodeName]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentNode;
        if (parent && SKIP_TAGS[parent.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) traduzirNoDeTexto(node);

    traduzirAtributosDoElemento(root);
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) traduzirAtributosDoElemento(els[i]);
  }

  function limparRegistros() {
    for (var i = 0; i < roots.length; i++) roots[i].observer.takeRecords();
  }

  function comGuarda(fn) {
    if (applying) return;
    applying = true;
    try {
      fn();
    } finally {
      limparRegistros();
      applying = false;
    }
  }

  // Processa apenas o que mudou — é isso que mantém o custo baixo com escopo body.
  function processarMutacoes(mutations) {
    comGuarda(function () {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            traduzirSubarvore(m.addedNodes[j]);
          }
        } else if (m.type === 'characterData') {
          traduzirNoDeTexto(m.target);
        } else if (m.type === 'attributes' && m.target.nodeType === Node.ELEMENT_NODE) {
          traduzirAtributosDoElemento(m.target);
        }
      }
    });
  }

  function jaRegistrado(el) {
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].el === el) return true;
    }
    return false;
  }

  function registrar(el) {
    if (jaRegistrado(el)) return;

    var observer = new MutationObserver(function (mutations) {
      if (applying) return;
      processarMutacoes(mutations);
    });

    roots.push({ el: el, observer: observer });

    comGuarda(function () { traduzirSubarvore(el); });

    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS
    });
  }

  function varrer() {
    roots = roots.filter(function (r) {
      if (document.contains(r.el)) return true;
      r.observer.disconnect();
      return false;
    });

    var achados = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < achados.length; i++) registrar(achados[i]);
  }

  function agendarVarredura() {
    if (rescanQueued) return;
    rescanQueued = true;
    requestAnimationFrame(function () {
      rescanQueued = false;
      varrer();
    });
  }

  function iniciar() {
    varrer();

    // Cobre o caso do root configurado ainda não existir na carga inicial.
    if (!roots.length) {
      var bodyObserver = new MutationObserver(agendarVarredura);
      bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { bodyObserver.disconnect(); }, 20000);
    }

    document.addEventListener('shopify:section:load', agendarVarredura);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();